import React from 'react';
import { Modal, Input } from 'antd';

const { TextArea } = Input;

/**
 * Shared "enter a reason" prompt used by every persona's admin management page
 * when rejecting a pending registration. Mirrors the reject modal used by
 * CompanyApprovalList.
 */
const RejectReasonModal = ({
  open,
  title = 'Reject Registration',
  entityLabel,
  reason,
  onReasonChange,
  onOk,
  onCancel,
  confirmLoading,
}) => (
  <Modal
    title={title}
    open={open}
    onOk={onOk}
    onCancel={onCancel}
    confirmLoading={confirmLoading}
    okText="Reject"
    okButtonProps={{ danger: true }}
  >
    {entityLabel && (
      <p>
        Entity: <strong>{entityLabel}</strong>
      </p>
    )}
    <TextArea
      rows={4}
      placeholder="Please provide a reason for rejection..."
      value={reason}
      onChange={(e) => onReasonChange(e.target.value)}
    />
  </Modal>
);

export default RejectReasonModal;
